import { render } from "./KsRsyAd.vue?vue&type=template&id=2cdc83cd&scoped=true"
import script from "./KsRsyAd.vue?vue&type=script&lang=js"
export * from "./KsRsyAd.vue?vue&type=script&lang=js"

import "./KsRsyAd.vue?vue&type=style&index=0&id=2cdc83cd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdc83cd"]])

export default __exports__